import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _SIIFAuxiliaryType, _SIIFTCON17Value } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { SIIFAuxiliaryTypeSelect } from "../SIIFAuxiliaryType/SIIFAuxiliaryTypeSelect";
import { SiifAuxiliaryCatalogSelect } from "../SIIFAuxiliaryCatalog/SiifAuxiliaryCatalogSelect";
import { BasicButton } from "../../../theme/Component/BasicButton";


export const SIIFTCON17 = () => {

    const SIIFTCON17Value = useDataBean(_SIIFTCON17Value);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [SIIFAuxiliary, setSIIFAuxiliary] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])
    useEffect(() => {
        getLista();
    }, [SIIFAuxiliary])
    const getLista = () => {

        SIIFTCON17Value.instance.getSIIFTCON17ValueByIDSIIFAuxiliary(SIIFAuxiliary).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        SIIFTCON17Value.setBean({
            IDSIIFAuxiliary: SIIFTCON17Value.bean.IDSIIFAuxiliary
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        SIIFTCON17Value.deleteItemVoid(SIIFTCON17Value.bean.IDSIIFTCON17Value).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        SIIFTCON17Value.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDSIIFTCON17Value', visible: true },
        { title: 'Auxiliar', property: 'SIIFAuxiliaryName', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${SIIFTCON17Value.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Auxiliares TCon17">
            <div className="row">
                <div className="col-md-6">
                    <SiifAuxiliaryCatalogSelect label='Auxiliar' idSelector={SIIFAuxiliary} onChange={(e) => { setSIIFAuxiliary(e) }} />
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={SIIFTCON17Value.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            {/* <div className="col-md-12">
                                <SIIFAuxiliaryTypeSelect idSelector={SIIFTCON17Value.bean.IDSIIFAuxiliary} onChange={(e) => { SIIFTCON17Value.setBean({ ...SIIFTCON17Value.bean, 'IDSIIFAuxiliary': e }) }} />
                            </div> */}
                            <div className="col-md-12">
                                <SiifAuxiliaryCatalogSelect idSelector={SIIFTCON17Value.bean.IDSIIFAuxiliary} onChange={(e) => { SIIFTCON17Value.setBean({ ...SIIFTCON17Value.bean, 'IDSIIFAuxiliary': e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={SIIFTCON17Value.bean.Code} onChange={SIIFTCON17Value.handleChange} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={SIIFTCON17Value.bean.Description} onChange={SIIFTCON17Value.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {SIIFTCON17Value.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}